module.exports = __webpack_public_path__ + "static/img/image-empty.72ac0eff.png";